module.exports = __webpack_public_path__ + "img/link-banner-ru.405b7412.png";